import api from '../../utils/axios';

export const notificationPrefService = {
    // Get notification preferences
    getPreferences: async () => {
        const response = await api.get('/notification-preferences');
        return response.data;
    },

    // Update notification preferences
    updatePreferences: async (data) => {
        const response = await api.put('/notification-preferences', data);
        return response.data;
    },

    // Send custom bulk notification
    sendCustomNotification: async (title, message, target) => {
        const response = await api.post('/notifications/send-custom', { title, message, target });
        return response.data;
    },

    // Get notification history
    getHistory: async () => {
        const response = await api.get('/notifications/agent/history');
        return response.data;
    }
};
